import React, { useEffect, useState } from 'react';
import { CompanyUser } from '../../../../../app/models/User';
import useHandleErrorFields from '../../../../../hooks/useHandleErrorFields';
import useRut from '../../../../../hooks/useRut';
import CountriesFormDefault from '../../../../../components/default/CountriesFormDefault';
import { Country } from '../../../../../app/models/Country';
import { Region } from '../../../../../app/models/Region';
import { Commune } from '../../../../../app/models/Commune';

interface GeneralUserProps {
    countries: Country[];
    regions: Region[];
    communes: Commune[];
    setRegions: (regions: Region[]) => void;
    setCommunes: (communes: Commune[]) => void;
    companyUserForm: CompanyUser;
    setCompanyUserForm: (company: CompanyUser) => void;
    errorFields?: any;
}

const CompanyUserForm = ({
    companyUserForm,
    setCompanyUserForm,
    errorFields,
    countries,
    regions,
    communes,
    setRegions,
    setCommunes
}: GeneralUserProps) => {
    const { fieldErrorMessage, fieldHasError, onFocusRemove, setErrors } = useHandleErrorFields();
    const { formatRut } = useRut();

    const [image, setImage] = useState(
        companyUserForm.company?.avatar
            ? companyUserForm.company?.avatar
            : 'https://static.vecteezy.com/system/resources/previews/009/292/244/original/default-avatar-icon-of-social-media-user-vector.jpg'
    );

    useEffect(() => {
        setErrors(errorFields);
    }, [errorFields]);

    const dataOnChangeImages = (e: any) => {
        const selectedFile = e.target.files[0];
        console.log(selectedFile);
        if (selectedFile) {
            setImage(URL.createObjectURL(selectedFile));
            setCompanyUserForm({
                ...companyUserForm,
                [e.target.name]: selectedFile
            });
        }
    };

    const removeImage = () => {
        setImage(
            'https://static.vecteezy.com/system/resources/previews/009/292/244/original/default-avatar-icon-of-social-media-user-vector.jpg'
        ); // Limpiar el estado de la imagen

        companyUserForm.company.avatar = undefined;
        setCompanyUserForm({ ...companyUserForm });
        const fileInput = document.getElementById('avatar') as HTMLInputElement | null;
        if (fileInput) {
            fileInput.value = '';
        }
    };

    const handleChange = (
        event: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>
    ) => {
        const { name, value, type } = event.target;
        if (type === 'checkbox') {
            event.target = event.target as HTMLInputElement;
            setCompanyUserForm({ ...companyUserForm, [name]: event.target.checked });
        } else {
            if (name == 'rut') {
                companyUserForm.company.rut = formatRut(value);
                setCompanyUserForm({ ...companyUserForm });
            } else {
                // si name contiene un punto quiere decir que hay que cambiar un objeto dentro del objeto
                if (name.includes('.')) {
                    const keys = name.split('.');
                    const updatedForm: any = { ...companyUserForm };

                    let nestedObject: any = updatedForm;
                    for (let i = 0; i < keys.length - 1; i++) {
                        const key = keys[i];
                        if (!nestedObject[key]) {
                            nestedObject[key] = {}; // Asegurarse de que el objeto anidado existe
                        }
                        nestedObject = nestedObject[key]; // Navegar al objeto anidado
                    }

                    nestedObject[keys[keys.length - 1]] = value; // Asignar el valor en la propiedad correcta

                    setCompanyUserForm(updatedForm);
                } else {
                    setCompanyUserForm({ ...companyUserForm, [name]: value });
                }
            }
        }
    };

    useEffect(() => {
        console.log(companyUserForm);
    }, [companyUserForm]);

    if (!companyUserForm) return null;

    return (
        <>
            <div className="mb-2 row">
                <div className="col-md-12">
                    <label className="col-form-label">Correo Electrónico *</label>
                    <input
                        name="user.email"
                        type="email"
                        className={`form-control ${fieldHasError('user.email')}`}
                        value={companyUserForm.user.email}
                        onChange={handleChange}
                        placeholder="name@company.com"
                    />
                    <div className="invalid-feedback">{fieldErrorMessage('user.email')}</div>
                </div>
            </div>
            <div className="mb-2 row">
                <div className="col-md-12">
                    <label className="col-form-label">Contraseña *</label>
                    <input
                        name="user.password"
                        type="password"
                        className={`form-control ${fieldHasError('user.password')}`}
                        value={companyUserForm.user.password}
                        onChange={handleChange}
                        placeholder="Contraseña"
                    />
                    <div className="invalid-feedback">{fieldErrorMessage('user.password')}</div>
                </div>
            </div>
            <div className="mb-2 row">
                <div className="col-md-12">
                    <label className="col-form-label">Repetir Contraseña *</label>
                    <input
                        name="user.repeat_password"
                        type="password"
                        className={`form-control ${fieldHasError('user.repeat_password')}`}
                        value={companyUserForm.user.repeat_password}
                        onChange={handleChange}
                        placeholder="Repetir Contraseña"
                    />
                    <div className="invalid-feedback">
                        {fieldErrorMessage('user.repeat_password')}
                    </div>
                </div>
            </div>

            <div className="mb-2 row">
                <div className="col-md-12">
                    <label className="col-form-label">Nombre *</label>
                    <input
                        name="user.first_name"
                        type="text"
                        className={`form-control ${fieldHasError('user.first_name')}`}
                        value={companyUserForm.user.first_name}
                        onChange={handleChange}
                        placeholder="Nombre"
                    />
                    <div className="invalid-feedback">{fieldErrorMessage('user.first_name')}</div>
                </div>
            </div>

            <div className="mb-2 row">
                <div className="col-md-12">
                    <label className="col-form-label">Apellido *</label>
                    <input
                        name="user.last_name"
                        type="text"
                        className={`form-control ${fieldHasError('user.last_name')}`}
                        value={companyUserForm.user.last_name}
                        onChange={handleChange}
                        placeholder="Apellido"
                    />
                    <div className="invalid-feedback">{fieldErrorMessage('user.last_name')}</div>
                </div>
            </div>

            <div className="mb-2 row">
                <div className="col-md-6">
                    <label className="col-form-label">Cargo *</label>
                    <input
                        name="job_title"
                        type="text"
                        className={`form-control ${fieldHasError('job_title')}`}
                        value={companyUserForm.job_title}
                        onChange={handleChange}
                        placeholder="Cargo"
                    />
                    <div className="invalid-feedback">{fieldErrorMessage('job_title')}</div>
                </div>
                <div className="col-md-6">
                    <label className="col-form-label">Teléfono *</label>
                    <div className="row">
                        <div className="col-auto">
                            <select
                                className="form-control"
                                id="phone_code"
                                name="phone_code"
                                onChange={handleChange}
                                value={companyUserForm.phone_code}
                            >
                                <option defaultValue={'+56'} value="+56">
                                    +56
                                </option>
                            </select>
                        </div>
                        <div className="col">
                            <input
                                name="phone"
                                type="text"
                                className={`form-control ${fieldHasError('phone')}`}
                                value={companyUserForm.phone}
                                onChange={handleChange}
                                placeholder="Teléfono"
                            />
                            <div className="invalid-feedback">{fieldErrorMessage('phone')}</div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CompanyUserForm;
